import config from "../config/config";
import { BUST_OUT_XP_PER_PERCENT } from "./xp";

export const JailWhiteListPath = [
  "/injail",
  "/jail",
  "/vault",
  "/buy",
  "/crate",
  "/rank",
  "/map",
  "/jackpot",
  "/roulette",
  "/slotmachine",
  "/garage",
  "/bullet/factory",
  "/bank",
  "/hospital",
  "/family",
  "/profile",
  "/market",
  "/exchange",
  "/inventory",
  "/perks",
  config.gitbookUrl,
];

// Paths that should redirect to jail when incarcerated
export const JAIL_RESTRICTED_PATHS = [
  "/crimes",
  "/nickcar",
  "/travel",
  "/killskill",
  "/kill-initiation",
  "/kill-outcome",
  "/racing",
  "/booze",
  "/narcotics",
  "/shop",
  "/helper",
];

// Same paths restricted when in safehouse (cannot do crimes while protected)
export const SAFEHOUSE_RESTRICTED_PATHS = [...JAIL_RESTRICTED_PATHS];

export const BribePerMin = 1500;

export const CrimeFailedReason = [
  "Basic Crime failed",
  "Basic Crime failed",
  "Basic Crime failed",
  "Basic Crime failed",
  "Booze buy failed",
  "Booze sell failed",
  "Narcotics buy failed",
  "Narcotics sell failed",
  "Bust out failed",
  "Nick car failed",
];


export const BUST_OUT_XP_AMOUNT = BUST_OUT_XP_PER_PERCENT;